<template>
  <AnnDialog
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
  >
    <div class="ann-how-to-play">
      <img
        class="ann-how-to-play-bg"
        :src="backgroundImg"
        alt=""
        aria-hidden="true"
      />
      <img
        class="ann-how-to-play-title"
        :src="titleImg"
        :alt="$t('ann2026.hero.howToPlay')"
      />
      <div class="ann-how-to-play-content">
        <div class="ann-how-to-play-scroll">
          <p>{{ t('ann2026.howToPlay.body') }}</p>
        </div>
      </div>
      <AnnDialogClose
        :aria-label="t('ann2026.dialog.close')"
        @close="emit('update:modelValue', false)"
      />
    </div>
  </AnnDialog>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import AnnDialog from '../AnnDialog/index.vue'
import AnnDialogClose from '../AnnDialogClose/index.vue'
import backgroundImg from '@/assets/imgs/act/ann2026/popups/how-to-play/background.png'
import titleZh from '@/assets/imgs/act/ann2026/popups/how-to-play/title/zh.png'
import titleEn from '@/assets/imgs/act/ann2026/popups/how-to-play/title/en.png'
import titleVi from '@/assets/imgs/act/ann2026/popups/how-to-play/title/vi.png'
import titleId from '@/assets/imgs/act/ann2026/popups/how-to-play/title/id.png'
import titleTh from '@/assets/imgs/act/ann2026/popups/how-to-play/title/th.png'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n({ useScope: 'global' })

const titleImg = computed(() => {
  switch (locale.value) {
    case 'hk':
    case 'tw':
      return titleZh
    case 'vi':
      return titleVi
    case 'id':
      return titleId
    case 'th':
      return titleTh
    default:
      return titleEn
  }
})
</script>

<style lang="less" scoped>
.ann-how-to-play {
  position: relative;
  width: 705px;
  height: 508px;
  overflow: visible;
}

.ann-how-to-play-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 705px;
  height: 508px;
  pointer-events: none;
}

.ann-how-to-play-title {
  position: absolute;
  // 设计意图：标题向上探出弹窗顶部边缘。
  top: -30px;
  left: 50%;
  z-index: 2;
  // 图片标题锁宽跟随缩放，height auto 保持各语言切图等比不变形。
  // width: 7rem;
  max-width: calc(100% - 40px);
  // height: auto;
  transform: translateX(-50%);
  height: 100px;

}

.ann-how-to-play-content {
  position: absolute;
  top: 120px;
  left: 69px;
  z-index: 2;
  width: 542px;
  height: 300px;
  background: transparent;
}

.ann-how-to-play-scroll {
  position: absolute;
  inset: 0 22px;
  overflow-y: auto;
  background: transparent;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  p {
    margin: 0;
    background: transparent;
    color: #fff;
    font-size: 20px;
    line-height: 27px;
    font-weight: 700;
    white-space: pre-line;
  }
}

</style>
